// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useTranslation } from 'react-i18next';
import { Button } from '@imprivata-cloud/design-system';

import { getPortalUrl } from '@/utils/utils';
import './UserAlreadySet.less';

const TRANSLATION_ROOT = 'setup.user-already-set';

export function UserAlreadySet() {
  const { t } = useTranslation();

  const ContinueToLogin = () => {
    window.location.assign(getPortalUrl());
  };

  return (
    <div className="user-already-set-container">
      <div className="user-already-set-card">
        <span className="user-already-set-title">{t(`${TRANSLATION_ROOT}.title`)}</span>

        <span className="user-already-set-description">{t(`${TRANSLATION_ROOT}.subtitle`)}</span>

        <Button
          variant="primary"
          size="sm"
          className="user-already-set-button"
          onClick={ContinueToLogin}
        >
          {t(`${TRANSLATION_ROOT}.login-now`)}
        </Button>
      </div>
    </div>
  );
}
